import React from 'react';
import Notification, { NOTIFICATION_TIMEOUT_INFINITE } from '@rio-cloud/rio-uikit/Notification';
import { KB_REQUEST_ACCESS_URL, KB_RENEW_ACCESS_URL, SLACK_SUPPORT_URL, JIRA_BOARD_URL, TEAM_EMAIL } from '~/features/base/constants/supportLinks';

export const PERMISSION_DENIED_NOTIFICATION = 'PERMISSION_DENIED_NOTIFICATION';

// Debounce: show one 403 notification per 5s window
const PERMISSION_DENIED_DEBOUNCE_MS = 5000;
let lastPermissionDeniedTimestamp = 0;

const buildPermissionDeniedContent = () => (
    <div className='text-color-dark'>
        <span className='text-size-14 text-bold'>{"You don't have access to this feature."}</span>
        <ul className='list-unstyled margin-top-10 margin-bottom-10'>
            <li className='margin-bottom-5'>
                <span className='uikit-icon icon-book margin-right-5'></span>
                <a href={KB_REQUEST_ACCESS_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary'>
                    Request access (KB)
                </a>
            </li>
            <li className='margin-bottom-5'>
                <span className='uikit-icon icon-refresh margin-right-5'></span>
                <a href={KB_RENEW_ACCESS_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary'>
                    Renew expired access (KB)
                </a>
            </li>
        </ul>
        <span className='text-size-12 text-color-gray'>Contact us:</span>
        <ul className='list-unstyled margin-top-5'>
            <li className='margin-bottom-5'>
                <span className='uikit-icon icon-comment margin-right-5'></span>
                <a href={SLACK_SUPPORT_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary'>
                    Slack support channel
                </a>
            </li>
            <li className='margin-bottom-5'>
                <span className='uikit-icon icon-envelope margin-right-5'></span>
                <a href={`mailto:${TEAM_EMAIL}`} className='text-color-primary'>
                    {TEAM_EMAIL}
                </a>
            </li>
        </ul>
    </div>
);

export const notifyPermissionDenied = (requestUrl) => (dispatch) => {
    const now = Date.now();
    if (now - lastPermissionDeniedTimestamp < PERMISSION_DENIED_DEBOUNCE_MS) {
        return;
    }
    lastPermissionDeniedTimestamp = now;

    const content = buildPermissionDeniedContent();

    Notification.error(content, {
        title: 'Permission Denied',
        timeout: NOTIFICATION_TIMEOUT_INFINITE,
    });

    dispatch({
        type: PERMISSION_DENIED_NOTIFICATION,
        payload: {
            message: "You don't have access to this feature",
            requestUrl,
            autoDismiss: false,
            links: {
                requestAccess: KB_REQUEST_ACCESS_URL,
                renewAccess: KB_RENEW_ACCESS_URL,
                slackSupport: SLACK_SUPPORT_URL,
                jiraBoard: JIRA_BOARD_URL,
                teamEmail: TEAM_EMAIL,
            },
        },
    });
};
